export class DeliveryRequest {
    public order_number;
    public supplier_code;
    public company_code;
    public language;
    public date_from;
    public date_to;
}



// WEBPACK FOOTER //
// ./src/app/model/delivery/delivery_request.model.ts